import type { ButtonProps } from 'common/uiV3/Button';

export const IntegrationButtonDefaultProps: Partial<ButtonProps> = {
  variant: 'outlined',
  size: 'xlarge',
  fullWidth: true,
  className: 'px-3',
};
